<template>
  <div class="container">
    <div class="row justify-content-center">
      <div :class="colsClass">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      center: { type: String, default: null }
    },

    computed: {
      colsClass () {
        if (this.center === null) {
          return 'col-12'
        }

        let base = this.center === '' ? 6 : parseInt(this.center)

        return `col-xl-${base} col-lg-${base += 2} col-md-${base += 2} col-12`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
</style>